export type OrderCreationFlow =
	| 'BASE'
	| 'CONTRACT_LOCATION_FIRST'
	| 'CONTRACT_AFTER_LOCATION';

export const CUSTOMER_STORE_FLOW = {
	BASE: 'BASE',
	CONTRACT_LOCATION_FIRST: 'CONTRACT_LOCATION_FIRST',
	CONTRACT_AFTER_LOCATION: 'CONTRACT_AFTER_LOCATION',
} as const;
